import { OrganizationRole } from "../model/OrganizationRole";
import API from "./base";

const list = (): Promise<OrganizationRole[]> => {
  return new Promise((resolve, reject) => {
    API.get("/organization-roles/list").then((result) => {
      resolve(result.data.payload as OrganizationRole[]);
    }, reject);
  });
};

const get = (organizationRoleId: string): Promise<OrganizationRole> => {
  return new Promise((resolve, reject) => {
    API.get(`/organization-roles/${organizationRoleId}`).then((result) => {
      resolve(result.data.payload as OrganizationRole);
    }, reject);
  });
};

const byOrganization = (
  organizationId: string,
): Promise<OrganizationRole[]> => {
  return new Promise((resolve, reject) => {
    API.get(`/organization-roles/byOrganization/${organizationId}`).then(
      (result) => {
        resolve(result.data.payload as OrganizationRole[]);
      },
      reject,
    );
  });
};

const assignToOrganization = (
  organizationRoleId: string,
  organizationId: string,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    API.post(
      `/organization-roles/${organizationRoleId}/assignToOrganization/${organizationId}`,
    ).then(() => resolve(), reject);
  });
};

const unassignToOrganization = (
  organizationRoleId: string,
  organizationId: string,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    API.post(
      `/organization-roles/${organizationRoleId}/unassignToOrganization/${organizationId}`,
    ).then(() => resolve(), reject);
  });
};

export default {
  list: list,
  get: get,
  byOrganization: byOrganization,
  assignToOrganization: assignToOrganization,
  unassignToOrganization: unassignToOrganization,
};
